import { useLayoutEffect } from "react";

/**
 * Adds a smooth fade-up reveal to every `.ee-section` as it scrolls into view.
 * Runs before paint (useLayoutEffect) so there is no flash of un-hidden content.
 */
export function useReveal() {
  useLayoutEffect(() => {
    const els = Array.from(document.querySelectorAll<HTMLElement>(".ee-section"));
    if (!els.length) return;

    els.forEach((el) => el.classList.add("reveal-init"));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
